module.exports = __webpack_public_path__ + "img/Picture17.22214132.png";